/** Deezer ids are numeric; anything else is rejected so a bad id can never end up in a URL. */
export type DeezerKind = 'track' | 'album';

export function isDeezerId(id: unknown): id is string | number {
  return /^\d+$/.test(String(id));
}

/** Page on deezer.com where the whole song or album can be played. */
export function deezerPageUrl(kind: DeezerKind, id: string | number): string | null {
  return isDeezerId(id) ? `https://www.deezer.com/${kind}/${id}` : null;
}

/** Deezer's embeddable player. It plays full songs for listeners logged in to Deezer, otherwise previews. */
export function deezerWidgetUrl(kind: DeezerKind, id: string | number): string | null {
  return isDeezerId(id) ? `https://widget.deezer.com/widget/auto/${kind}/${id}?autoplay=true&tracklist=${kind === 'album'}` : null;
}
